import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { accentColors } from '../design/theme';

interface TickerLinkProps {
  ticker: string;
  variant?: TypographyProps['variant'];
  fontWeight?: number;
}

/** Ticker text that deep-links to the stock's universe page. Stops event
 *  propagation so it can sit inside table rows whose own click opens the
 *  candle-chart modal — ticker → universe, rest of the row → modal. */
const TickerLink: React.FC<TickerLinkProps> = ({ ticker, variant = 'body2', fontWeight = 700 }) => {
  const navigate = useNavigate();

  const go = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    navigate(`/universe/${ticker}`);
  };

  return (
    <Typography
      variant={variant}
      component="span"
      role="link"
      tabIndex={0}
      aria-label={`View ${ticker} in universe`}
      onClick={go}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          go(e);
        }
      }}
      sx={{
        fontWeight,
        color: accentColors.ticker,
        cursor: 'pointer',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      {ticker}
    </Typography>
  );
};

export default TickerLink;
